import axios from '../../../build/http-requests/axios-common'
import modules from '../vuex-modules'

export default {
  state: {
    isLoggedIn: !!localStorage.getItem('token'),
    user: null,
    userEmail: null,
    userId: null
  },

  mutations: {
    LOGIN (state) {
      state.pending = true
      state.selectedMenuItem = null
    },

    LOGIN_SUCCESS (state, user) {
      state.isLoggedIn = true
      state.pending = false
      state.user = user.name
      state.userEmail = user.email
      state.userId = user.idUsuario
    },

    LOGOUT (state) {
      state.isLoggedIn = false
      state.client = null
      state.clientApps = []
      state.profileToEditId = null
      state.clientName = null
      state.selectedMenuItem = null
    },

    UPDATE_USER_NAME (state, username) {
      state.user = username
    },

    CLEAN_MODULES () {
      let self = this
      Object.keys(modules).forEach(function (value, index) {
        if (self.state[value]) {
          self.state[value] = modules[value]
        }
      })
    }
  },

  actions: {
    cleanVuexModules: ({ commit }) => {
      commit('CLEAN_MODULES')
    },

    login: ({ commit }, credentials) => {
      commit('CLEAN_MODULES')
      commit('LOGIN') // show spinner
      localStorage.setItem('event-login-start', Math.random())
      return new Promise((resolve, reject) => {
        axios.post('/user/login', { username: credentials.username, password: credentials.password, recaptcha: credentials.recaptcha }).then(response => {
          let token = response.headers['x-access-token']
          let user = {
            name: (response && response.data && response.data.data && response.data.data.nome ? response.data.data.nome : ''),
            email: (response && response.data && response.data.data && response.data.data.email ? response.data.data.email : ''),
            idUsuario: (response && response.data && response.data.data && response.data.data.idUsuario ? response.data.data.idUsuario : '')
          }
          localStorage.setItem('token', token)
          commit('LOGIN_SUCCESS', user)
          resolve()
        }).catch((error) => {
          commit('LOGOUT')
          reject(error)
        })
      })
    },

    logout: ({ commit }) => {
      localStorage.removeItem('token')
      commit('LOGOUT')
      commit('CLEAN_MODULES')
      const response = axios.get('/user/logout')
      localStorage.setItem('event-logout', Math.random())
      return response
    },

    recoverPassword: ({ commit }, recoverPasswordData) => {
      return new Promise((resolve, reject) => {
        axios.post('/user/recoveryPassword', { data: recoverPasswordData }).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },

    registerPassword: ({ commit }, credentials) => {
      return new Promise((resolve, reject) => {
        axios.post('/user/newPassword', {
          username: credentials.username,
          password: credentials.password,
          confirmPassword: credentials.confirmPassword,
          key: credentials.key
        }).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },

    registerRecoverPassword: ({ commit }, credentials) => {
      return new Promise((resolve, reject) => {
        axios.post('/user/changePassword', {
          username: credentials.username,
          password: credentials.password,
          confirmPassword: credentials.confirmPassword,
          key: credentials.key
        }).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },

    loginEmulado: ({ commit }, data) => {
      commit('CLEAN_MODULES')
      commit('LOGIN') // show spinner
      return new Promise((resolve, reject) => {
        axios.post('/user/loginEmulado', { token: data.token, lang: data.idioma }).then(response => {
          let token = response.headers['x-access-token']
          let user = {
            name: (response && response.data && response.data.data && response.data.data.usuario ? response.data.data.usuario.nome : ''),
            email: (response && response.data && response.data.data && response.data.data.usuario ? response.data.data.usuario.email : '')
          }
          localStorage.setItem('token', token)
          commit('LOGIN_SUCCESS', user)
          resolve(response.data.data)
        }).catch((error) => {
          commit('LOGOUT')
          reject(error)
        })
      })
    },

    loginTrocaAplicacao: ({ commit }, data) => {
      commit('CLEAN_MODULES')
      commit('LOGIN') // show spinner
      return new Promise((resolve, reject) => {
        axios.post('/user/changeApplication', { token: data.token, lang: data.idioma }).then(response => {
          let token = response.headers['x-access-token']
          let user = {
            name: (response && response.data && response.data.data && response.data.data.usuario ? response.data.data.usuario.nome : ''),
            email: (response && response.data && response.data.data && response.data.data.usuario ? response.data.data.usuario.email : '')
          }
          localStorage.setItem('token', token)
          commit('LOGIN_SUCCESS', user)
          resolve(response.data.data)
        }).catch((error) => {
          commit('LOGOUT')
          reject(error)
        })
      })
    },

    tentativas: () => {
      return new Promise((resolve, reject) => {
        axios.get('/user/login/tentativas').then(response => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    cleanSession: ({ commit }) => {
      commit('LOGOUT')
    }
  },

  getters: {
    isLoggedIn: state => state.isLoggedIn,
    user: state => state.user,
    userEmail: state => state.userEmail,
    userId: state => state.userId
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/login.js